'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var _ = require('lodash');  /* jshint ignore:line */
var FlowList = require('./v1/flow').FlowList;
var Version = require('../../base/Version');  /* jshint ignore:line */


/* jshint ignore:start */
/**
 * Initialize the V1 version of Studio
 *
 * @constructor Twilio.Studio.V1
 *
 * @property {Twilio.Studio.V1.FlowList} flows - flows resource
 *
 * @param {Twilio.Studio} domain - The twilio domain
 */
/* jshint ignore:end */
function V1(domain) {
  Version.prototype.constructor.call(this, domain, 'v1');

  // Resources
  this._flows = undefined;
}

_.extend(V1.prototype, Version.prototype);
V1.prototype.constructor = V1;

Object.defineProperty(V1.prototype,
  'flows', {
    get: function() {
      this._flows = this._flows || new FlowList(this);
      return this._flows;
    }
});

module.exports = V1;
